/* zoom
  ========================================================================== */
export default function zoom() {
    const zoomContainers = document.querySelectorAll('[data-role="zoom"]');
    let currentlyZoomedContainer = null;
    zoomContainers.forEach((zoomContainer) => {
        let positionX;
        let positionY;
        const onMousemove = ({ offsetX, offsetY }) => {
            positionX = (offsetX / zoomContainer.offsetWidth) * 100;
            positionY = (offsetY / zoomContainer.offsetHeight) * 100;
            zoomContainer.style.setProperty('--zoom-position-x', `${positionX}%`);
            zoomContainer.style.setProperty('--zoom-position-y', `${positionY}%`);
        };
        const onClick = (event) => {
            event.preventDefault();
            if (currentlyZoomedContainer === zoomContainer) {
                // If clicking on the already zoomed element, unzoom it
                zoomContainer.classList.remove('is-visible');
                currentlyZoomedContainer = null;
            }
            else {
                // Unzoom the previously zoomed element and zoom the new element
                currentlyZoomedContainer?.classList.remove('is-visible');
                zoomContainer.classList.add('is-visible');
                currentlyZoomedContainer = zoomContainer;
                onMousemove(event);
            }
        };
        zoomContainer.addEventListener('mousemove', onMousemove);
        zoomContainer.addEventListener('click', onClick);
    });
}
